export const extensionRoutes = [  {
    path: 'extensions/credit',
    loadChildren: () => import('./extensions/127f7e741a0df228f390786c59b6e09930ad86e153c8c0b21ef19c2caeaef52f/credit-ui-extension.module').then(m => m.CreditUiExtensionModule),
  }];
